import angular from 'angular';

export const LAYOUTS_MODULE = 'app.layouts';

angular.module(LAYOUTS_MODULE, ['app.core', 'app.shared']);

export default LAYOUTS_MODULE;
